var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2001 31.29C34.2001 31.8808 33.8653 32.463 33.2237 32.9883C32.5821 33.5136 31.6521 33.9666 30.5112 34.3098C29.3703 34.6529 28.0514 34.8762 26.6645 34.9611C25.2775 35.046 23.8624 34.99 22.5372 34.7978C21.2119 34.6056 20.0147 34.2827 19.0452 33.8561C18.0757 33.4294 17.362 32.9113 16.9634 32.3449C16.5649 31.7785 16.493 31.1801 16.7538 30.5996",
    stroke: "#CA1211",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9996 22.9601C17.0969 18.6275 20.3901 13.75 25.3999 13.75C30.4097 13.75 33.7028 18.6275 31.8002 22.9601L28.7381 29.933C28.1803 31.2033 26.8721 32.05 25.3999 32.05C23.9277 32.05 22.6195 31.2033 22.0617 29.933L18.9996 22.9601Z",
    stroke: "#CA1211",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.3999,
    cy: 19.6004,
    r: 2.2,
    stroke: "#CA1211",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.4d201f2ad5bc1bc7d5a05c557d2f2d1a.svg";
export { ForwardRef as ReactComponent };